import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/kenaikanpangkatService";

import DataTableBloc from "../Blocs/DataTableBloc";
import apiResponse from "../../../../../services/apiResponse";

const reformatDate = (date) => {
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const d = new Date(date);
  let dt = d.getDate();
  if (dt < 10) dt = "0" + dt;

  return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
};

class TableActiveComponent extends Component {
  dataTableBloc = new DataTableBloc();

  source;
  historyTable = "PeriodePromotionTableActive";
  defaultOrder = "period_promotion_id";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      approveUuid: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });
  updatestatus = (period_promotion_uuid) => {
    console.log(period_promotion_uuid);
    this.dataTableBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              //rankItems: reformatRank(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.dataTableBloc.fetchCreate({
      period_promotion_uuid: period_promotion_uuid,
    });
  };
  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.inactiveData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.inactiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              //this.props.handleInactiveSuccess()
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel.unsubscribe();
  }

  columns = [
    {
      key: "period_promotion_date",
      text: "Period",
      sortable: true,
      cell: (record) => {
        return reformatDate(record.period_promotion_date);
      },
    },
    {
      key: "period_promotion_uuid",
      text: "Jumlah Penerima",
      sortable: false,
      cell: (record) => {
        return record.jumlah_pegawai + " Orang";
      },
    },
    {
      key: "period_promotion_status",
      text: "Status",
      sortable: true,
      cell: (record) => {
        //console.log('cek ', record)
        if (record.period_promotion_status) {
          let status = parseInt(record.period_promotion_status);
          if (status == 1) {
            status = (
              <label className="badge rounded-pill bg-soft-success font-size-12">
                Selesai
              </label>
            );
          } else if (status == 2) {
            status = (
              <label className="badge rounded-pill bg-soft-danger font-size-12">
                Ditolak
              </label>
            );
          } else {
            status = (
              <label className="badge rounded-pill bg-soft-info font-size-12">
                Menunggu Proses
              </label>
            );
          }
          return <span> {status} </span>;
        }
        return (
          <label className="badge rounded-pill bg-soft-info font-size-12">
            Menunggu Proses
          </label>
        );
      },
    },

    {
      key: "period_promotion_data_source",
      text: "Sumber data",
      sortable: true,
      cell: (record) => {
        //console.log('cek ', record)
        if (record.period_promotion_data_source) {
          let status = parseInt(record.period_promotion_data_source);
          if (status == 0) {
            status = (
              <label className="badge rounded-pill bg-soft-success font-size-12">
                {record.period_promotion_data_source_name}
              </label>
            );
          } else {
            status = (
              <label className="badge rounded-pill bg-soft-success font-size-12">
                {record.period_promotion_data_source_name}
              </label>
            );
          }
          {
          }
          return <span> {status} </span>;
        }
      },
    },

    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.period_promotion_id;
        const status = record.period_promotion_status;
        return (
          <Fragment>
            {record.award_period_approval_status !== 1 && (
              <Fragment>
                {accessRole("update") ? (
                  <span>
                    <button
                      className="btn btn-warning btn-sm"
                      id={"update-" + thisId}
                      onClick={() => {
                        this.setState({
                          updateUuid: record.period_promotion_uuid,
                        });
                      }}
                      style={{
                        marginRight: "2px",
                        padding: "2px 5px",
                      }}
                    >
                      <i className="uil-plus"></i>
                    </button>
                    <Tooltip
                      style={{
                        marginBottom: 2,
                      }}
                      placement="top"
                      isOpen={this.state["update" + thisId]}
                      target={"update-" + thisId}
                      toggle={() => {
                        this.setState({
                          ["update" + thisId]: !this.state["update" + thisId],
                        });
                      }}
                    >
                      Tambah Pegawai
                    </Tooltip>
                  </span>
                ) : null}

                {accessRole("delete") &&
                  status == 0 &&
                  record.jumlah_pegawai == 0 && (
                    <span>
                      <button
                        className="btn btn-danger btn-sm"
                        type="button"
                        id={"delete-" + thisId}
                        onClick={() => {
                          this.setState({
                            inactiveUuid: record.period_promotion_uuid,
                            confirm: true,
                          });
                        }}
                        style={{
                          padding: "2px 5px",
                        }}
                      >
                        <i className="uil-trash-alt"></i>
                      </button>
                      <Tooltip
                        style={{
                          marginBottom: 2,
                        }}
                        placement="top"
                        isOpen={this.state["delete" + thisId]}
                        target={"delete-" + thisId}
                        toggle={() => {
                          this.setState({
                            ["delete" + thisId]: !this.state["delete" + thisId],
                          });
                        }}
                      >
                        Hapus
                      </Tooltip>
                    </span>
                  )}

                {/* { accessRole('approve') && 
                                    <span>
                                        <button
                                            className="btn btn-success btn-sm"
                                            id={"approve-" + thisId}
                                            onClick={() => {
                                                this.updatestatus({
                                                    period_promotion_uuid : record.period_promotion_uuid
                                                })
                                            }}
                                            style={{
                                                marginRight: '2px',
                                                padding: '2px 5px'
                                            }}>
                                                <i className="uil-user-check"></i>
                                        </button>
                                        <Tooltip
                                            style={{
                                                marginBottom: 2
                                            }}
                                            placement="top" isOpen={this.state["approve-" + thisId]} target={"approve-" + thisId}
                                            toggle={() => {
                                                this.setState({
                                                    ["approve-" + thisId] : !this.state["approve-" + thisId]
                                                })
                                            }}
                                        >Selesaikan Proses</Tooltip>
                                    </span>
                                } */}
              </Fragment>
            )}
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menghapus data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil dihapus"
          failedTitle="Gagal!"
          failedInfo="Data gagal dihapus"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/kenaikan_pangkat.html?detail&uuid=" +
              this.state.detailUuid
            }
          />
        ) : null}
        {this.state.updateUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/kenaikan_pangkat.html?pegawai&uuid=" +
              this.state.updateUuid
            }
          />
        ) : null}
        {this.state.approveUuid !== null && (
          <Redirect
            to={
              "/kepegawaian/kenaikan_pangkat.html?approveperiode&uuid=" +
              this.state.approveUuid
            }
          />
        )}
      </>
    );
  }
}

export default TableActiveComponent;
